<template>
  <div class="mb-4">
    <ul class="-mb-px flex flex-wrap text-center text-sm font-medium">
      <slot></slot>
    </ul>
  </div>
</template>

<script setup lang="ts"></script>
